export default __webpack_public_path__ + "static/media/left-angle.76f894bb.svg";